export const FETCH_HOLIDAYS = "FETCH_HOLIDAYS";
export const FETCH_HOLIDAYS_SUCCESS = "FETCH_HOLIDAYS_SUCCESS";
export const FETCH_HOLIDAYS_FAILURE = "FETCH_HOLIDAYS_FAILURE";

export const CREATE_HOLIDAY = "CREATE_HOLIDAY";
export const CREATE_HOLIDAY_SUCCESS = "CREATE_HOLIDAY_SUCCESS";
export const CREATE_HOLIDAY_FAILURE = "CREATE_HOLIDAY_FAILURE";

export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY";
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS";
export const UPDATE_HOLIDAY_FAILURE = "UPDATE_HOLIDAY_FAILURE";

export const DELETE_HOLIDAY = "DELETE_HOLIDAY";
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS";
export const DELETE_HOLIDAY_FAILURE = "DELETE_HOLIDAY_FAILURE";

export const FETCH_HOLIDAY_EMPLOYEE = 'FETCH_HOLIDAY_EMPLOYEE';
export const FETCH_HOLIDAY_EMPLOYEE_SUCCESS = 'FETCH_HOLIDAY_EMPLOYEE_SUCCESS';
export const FETCH_HOLIDAY_EMPLOYEE_FAILURE = 'FETCH_HOLIDAY_EMPLOYEE_FAILURE';

export const SAVE_HOLIDAY_PROCESS = 'SAVE_HOLIDAY_PROCESS';
export const SAVE_HOLIDAY_PROCESS_SUCCESS = 'SAVE_HOLIDAY_PROCESS_SUCCESS';
export const SAVE_HOLIDAY_PROCESS_FAILURE = 'SAVE_HOLIDAY_PROCESS_FAILURE';

export const REMOVE_EMPLOYEE_HOLIDAY = 'REMOVE_EMPLOYEE_HOLIDAY';
export const REMOVE_EMPLOYEE_HOLIDAY_SUCCESS = 'REMOVE_EMPLOYEE_HOLIDAY_SUCCESS';
export const REMOVE_EMPLOYEE_HOLIDAY_FAILURE = 'REMOVE_EMPLOYEE_HOLIDAY_FAILURE';

export const RESET_HOLIDAY_EMPLOYEES = 'RESET_HOLIDAY_EMPLOYEES';

export const FETCH_HOLIDAY_PROCESS_LIST_REQUEST = 'FETCH_HOLIDAY_PROCESS_LIST_REQUEST';
export const FETCH_HOLIDAY_PROCESS_LIST_SUCCESS = 'FETCH_HOLIDAY_PROCESS_LIST_SUCCESS';
export const FETCH_HOLIDAY_PROCESS_LIST_FAILURE = 'FETCH_HOLIDAY_PROCESS_LIST_FAILURE';
